/**
 * display labels if no connection to server
 */
export default {
   lbl_no_server_connection: 'Keine Verbindung zum Server!',
   lbl_login_headline: 'Anmeldung',
   lbl_login_email_or_username: 'Email oder Benutzername',
   lbl_password: 'Passwort',
   app_lbl_action_login: 'Anmelden',
   warning_lbl_all_required: 'Alle Felder müssen ausgefüllt werden',
}


// WEBPACK FOOTER //
// ./src/Banet/data/defaultTranslations.js